/** Стереть копию данных на устройстве (IndexedDB «chat-cache»). Не ждём дольше секунды: в WKWebView запрос может не ответить. */
export function dropOfflineCopy(): Promise<void> {
  return new Promise((resolve) => {
    const timer = window.setTimeout(resolve, 1000);
    const finish = () => {
      window.clearTimeout(timer);
      resolve();
    };
    try {
      const req = indexedDB.deleteDatabase('chat-cache');
      req.onsuccess = finish;
      req.onerror = finish;
      req.onblocked = finish;
    } catch {
      finish();
    }
  });
}
